import React, { useEffect, useState, useCallback } from 'react';
import api from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../components/ui/dialog';
import { Plus, Trash2 } from 'lucide-react';
import { toast } from 'sonner';

const EMPTY = { question: '', answer: '', order: 0 };

export default function AdminFaqs() {
  const [items, setItems] = useState([]);
  const [dialog, setDialog] = useState(false);
  const [form, setForm] = useState(EMPTY);

  const load = useCallback(async () => {
    const { data } = await api.get('/faqs');
    setItems(data);
  }, []);
  useEffect(() => { load(); }, [load]);

  const save = async () => {
    try {
      await api.post('/faqs', { ...form, order: Number(form.order) });
      toast.success('FAQ agregada');
      setDialog(false);
      setForm(EMPTY);
      load();
    } catch { toast.error('Error'); }
  };

  const remove = async (id) => {
    if (!window.confirm('¿Eliminar?')) return;
    await api.delete(`/faqs/${id}`);
    load();
  };

  return (
    <div data-testid="admin-faqs-page">
      <div className="flex items-center justify-between mb-6 gap-3 flex-wrap">
        <div>
          <h1 className="font-display text-3xl text-slate-900">Preguntas frecuentes</h1>
          <p className="text-slate-500 text-sm">{items.length} preguntas</p>
        </div>
        <Button onClick={() => setDialog(true)} className="rounded-full btn-pink" data-testid="add-faq-btn">
          <Plus className="h-4 w-4 mr-1" /> Nueva pregunta
        </Button>
      </div>

      <div className="space-y-3">
        {items.map((f) => (
          <div key={f.id} data-testid={`faq-row-${f.id}`} className="bg-white border border-slate-200 rounded-2xl p-5 flex items-start gap-4">
            <div className="flex-1">
              <p className="font-semibold text-slate-900">{f.question}</p>
              <p className="text-sm text-slate-600 mt-1">{f.answer}</p>
            </div>
            <button onClick={() => remove(f.id)} className="text-rose-600 hover:bg-rose-50 h-8 w-8 rounded-lg inline-flex items-center justify-center" data-testid={`delete-faq-${f.id}`}>
              <Trash2 className="h-4 w-4" />
            </button>
          </div>
        ))}
      </div>

      <Dialog open={dialog} onOpenChange={setDialog}>
        <DialogContent>
          <DialogHeader><DialogTitle className="font-display text-2xl">Nueva FAQ</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div><Label>Pregunta</Label><Input value={form.question} onChange={(e) => setForm({ ...form, question: e.target.value })} className="rounded-xl" /></div>
            <div><Label>Respuesta</Label><Textarea rows={3} value={form.answer} onChange={(e) => setForm({ ...form, answer: e.target.value })} className="rounded-xl" /></div>
            <div><Label>Orden</Label><Input type="number" value={form.order} onChange={(e) => setForm({ ...form, order: e.target.value })} className="rounded-xl" /></div>
          </div>
          <DialogFooter>
            <Button variant="outline" className="rounded-full" onClick={() => setDialog(false)}>Cancelar</Button>
            <Button onClick={save} disabled={!form.question || !form.answer} className="rounded-full btn-pink">Guardar</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
